export default __webpack_public_path__ + "static/media/66fafaf14ab12525.0814b2e03ea83048bb468f0400824569.svg";